//ページトップに戻る
let start_pos = 0;
function Animation() {

	//アイコン位置取得
	let pageTop =  document.getElementById('gototop');
	let footer =  document.getElementById('footer');
	let fish = pageTop.clientHeight;
	// console.log(footer.getBoundingClientRect());

	// 画面の高さを取得
	let windowHeight = window.innerHeight;

	//要素の位置座標を取得
	// let rect = pageTop.getBoundingClientRect();
	let rect = footer.getBoundingClientRect().top - windowHeight + 60;
	// console.log(rect);
	//topからの距離
	// let scrollTop = window.pageYOffset;
	let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	var current_pos = scrollTop;

	// console.log("start_pos :"+ start_pos);
	// console.log("current_pos :"+ current_pos);

	if( 100 < scrollTop && 0 < rect ){

		if (current_pos > start_pos) {
		//down
			pageTop.classList.remove('upshow');
			pageTop.classList.add('downshow');
			pageTop.style.bottom = 23 + "px";
			pageTop.classList.remove('stop');
			// pageTop.removeAttribute('style');
		}else{
		//up
			pageTop.classList.remove('downshow');
			pageTop.classList.add('upshow');
			pageTop.style.bottom = 23 + "px";
			pageTop.classList.remove('stop');
		}

	}  else if( 0 >= rect ){

		pageTop.classList.add('stop');
		pageTop.style.bottom = footer.getBoundingClientRect().height + 107 + "px";
		pageTop.classList.remove('downshow');
		pageTop.classList.remove('upshow');

	}  else {
		pageTop.removeAttribute('style');
		pageTop.classList.remove('stop');
		pageTop.classList.remove('downshow');
		pageTop.classList.remove('upshow');

	}

	start_pos = current_pos;
};

window.addEventListener("DOMContentLoaded", Animation);
window.addEventListener("scroll", Animation);
